//istanbul ignore file
//tslint:disable

import { IHttpApi } from '@cian/http-api';

import {
  TChatsOfferModel,
  IChatsOfferRequest,
  IMappers,
  IChatsOfferResponse,
  IChatsOfferResponseError,
  TChatsOfferResponse,
} from './types';

const defaultConfig: TChatsOfferModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'chats',
  pathApi: '/v1/chats/offer/',
};

function createChatsOfferModel(parameters: IChatsOfferRequest): TChatsOfferModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

async function getChatsOfferMarkup<TResponse200, TResponse400>(
  httpApi: IHttpApi,
  parameters: IChatsOfferRequest,
  mappers: IMappers<TResponse200, TResponse400>,
): Promise<TResponse200 | TResponse400 | TChatsOfferResponse>;

async function getChatsOfferMarkup(httpApi: IHttpApi, parameters: IChatsOfferRequest): Promise<TChatsOfferResponse>;

async function getChatsOfferMarkup<TResponse200, TResponse400>(
  httpApi: IHttpApi,
  parameters: IChatsOfferRequest,
  mappers?: IMappers<TResponse200, TResponse400>,
) {
  const { response, statusCode } = await httpApi.fetch(createChatsOfferModel(parameters));

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IChatsOfferResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IChatsOfferResponseError);
    }
  }

  return { response, statusCode };
}

export { defaultConfig, createChatsOfferModel, getChatsOfferMarkup };
